import React, { useEffect } from "react";

import { routes } from "./Routes";

import { Spin } from "antd";
import { Route, Switch, Redirect } from "react-router-dom";
import useAuth from "./hooks/auth/useAuth";
import useLoggedInToken from "./helperHooks/useLoggedIn";
import useRedirect from "./helperHooks/useRedirect";

import Layout from "./components/layout";
//pages
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import Registration from "./pages/registration/Registration";
import EligibilityView from "./pages/eligibilityView/EligibilityView";
import EligibilityGetStarted from "./pages/eligibilityGetstarted/EligibilityGetstarted";
import UploadBill from "./pages/bills/uploadBill/UploadBill";
import Profile from "./pages/profile/Profile";
import BillsList from "./pages/bills/billList/BillsList";
import ReportIssue from "./pages/loginIssue/LoginIssue";
import BillsContainer from "./pages/bills/BillsContainer";
import Documents from "./pages/documents/Documents";
import useEligibilityMetaData from "./hooks/auth/useEligibilityMetaData";
import TermsOfUse from "pages/static/TermsOfUse";
import PrivacyPolicy from "pages/static/PrivacyPolicy";
import BorrowerConsentTerms from "pages/static/BorrowerConsentTerms";
import UtilityComponent from "UtilityComponent";

/**
 * routing is Decoupled from App.tsx for faster initial paint, lazy-loading this
 */
const RoutesContainer: React.FC = () => {
  const loggedIn = useLoggedInToken();
  const {
    getEligibilityMetaData,
    eligibilityMetaData,
    // Using gstin here as the loading flag.
    eligibilityMetaData: { gstin }
  } = useEligibilityMetaData();

  const redirect = useRedirect();

  //getting eligibilityMetaData on page load, if data not already present(from login)
  useEffect(() => {
    if (loggedIn && !eligibilityMetaData.gstin) {
      getEligibilityMetaData(redirect);
    }
  }, [eligibilityMetaData.gstin, getEligibilityMetaData, loggedIn, redirect]);

  return (
    <Switch>
      <Route path={routes.login.new} exact>
        <Login />
      </Route>
      <Route path={routes.registration.new} exact>
        <Registration />
      </Route>
      <Route path={routes.reportIssue.new} exact>
        <ReportIssue />
      </Route>
      <Route path={routes.static.tou} exact>
        <TermsOfUse />
      </Route>
      <Route path={routes.static.pp} exact>
        <PrivacyPolicy />
      </Route>
      <Route path={routes.static.bct} exact>
        <BorrowerConsentTerms />
      </Route>
      <React.Fragment>
        <Spin delay={250} spinning={!gstin} size="large">
          <Layout>
            <PrivateRoute isAuthenticated={loggedIn && !!gstin}>
              <Route path={routes.home.new} exact>
                <Home />
              </Route>
              <Route path={routes.home.initializeEligibility} exact>
                <Home />
                <EligibilityGetStarted />
              </Route>
              <Route path={routes.profile.new} exact>
                <Profile />
              </Route>
              <Route path={routes.bills.upload}>
                <BillsContainer currentTab="1" />
                <UploadBill />
              </Route>
              <Route path={routes.bills.new}>
                <BillsContainer currentTab="2" />
                <BillsList />
              </Route>
              <Route path={routes.eligibility.new} exact>
                <EligibilityView />
              </Route>
              <Route path={routes.eligibility.config} exact>
                <EligibilityView />
              </Route>
              <Route path={routes.documents.new} exact>
                <Documents />
              </Route>

              {/* Default route */}
              <Redirect from="*" to={routes.home.new}>
                <Home />
              </Redirect>
            </PrivateRoute>
            <UtilityComponent></UtilityComponent>
          </Layout>
        </Spin>
      </React.Fragment>
    </Switch>
  );
};
interface RouteProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
}
const PrivateRoute: React.FC<RouteProps> = (props: RouteProps) => {
  const {
    loginState: { loading }
  } = useAuth();
  const loggedIn = useLoggedInToken();

  return (
    <Route
      render={({ location }) =>
        props.isAuthenticated ? (
          <Switch>{props.children}</Switch>
        ) : (
          !loggedIn &&
          !loading && (
            <Redirect
              to={{ pathname: routes.login.new, state: { from: location } }}
            />
          )
        )
      }
    />
  );
};

export default RoutesContainer;
